import React, { useEffect, useState, useRef } from "react";
import { Spin, Typography, Button } from "antd";
import FormService from "../../services/FormService";
import cert from "../../images/certificate_bg.jpg"; // Make sure this resolves to a public image
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const { Text } = Typography;

const formatDateToMongolian = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  return `${year} оны ${month} дугаар сарын ${day}`;
};

export default function CertificatePage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const certificateRef = useRef(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await FormService.getMyForm();
        setData(res.data);
      } catch (error) {
        console.error("Error fetching form:", error);
        setData(null);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const handleDownloadPDF = async () => {
    const element = certificateRef.current;
    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("portrait", "mm", "a4");
    const pdfWidth = 210;
    const pdfHeight = 297;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("certificate.pdf");
  };

  if (loading) {
    return (
      <Spin size="large" style={{ display: "block", margin: "100px auto" }} />
    );
  }

  if (!data) {
    return (
      <div style={{ textAlign: "center", marginTop: 100 }}>
        <Text type="danger" strong>
          Сертификат олдсонгүй.
        </Text>
      </div>
    );
  }

  const profile = data.user.profile;

  return (
    <div>
      <Button
        onClick={handleDownloadPDF}
        type="primary"
        style={{ marginBottom: 20, display: "block", marginLeft: "auto" }}
      >
        PDF татах
      </Button>

      <div
        id="certificate"
        ref={certificateRef}
        style={{
          width: "210mm",
          height: "297mm",
          padding: "250px 150px 150px 150px",
          margin: "0 auto",
          boxSizing: "border-box",
          position: "relative",
          userSelect: "none",
          backgroundImage: `url(${cert})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <h1
          style={{
            color: "#3a6dcc",
            fontWeight: "bold",
            fontSize: "48px",
            textAlign: "center",
            textShadow: "2px 2px 0 #e81c7a",
            marginBottom: "10px",
            letterSpacing: "1.5px",
          }}
        >
          БАТЛАМЖ
        </h1>

        <p
          style={{
            textAlign: "center",
            marginTop: 0,
            marginBottom: 40,
            fontWeight: "bold",
            fontSize: 18,
          }}
        >
          ЭРХЭМ
        </p>

        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "24px",
            color: "#001f4d",
            margin: 0,
          }}
        >
          {profile.firstName?.toUpperCase() || ""} овогтой{" "}
          {profile.lastName?.toUpperCase() || ""}
        </p>

        <p
          style={{
            textAlign: "center",
            fontSize: "16px",
            margin: "20px 0",
          }}
        >
          ТАНД
          <br />
          2024-2025 оны хичээлийн жилд Монгол-Германы хамтарсан <br />
          <b>“Ажил мэргэжлийн чиг баримжаа олгох”</b> загвар төслийн <br />
          үйл ажиллагаанд амжилттай хамрагдсан тул энэхүү <br />
          <b>БАТЛАМЖ</b>-ийг олгов.
        </p>

        <div
          style={{
            marginTop: 60,
            fontSize: 16,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            Мэргэжлийн чиглэл: <b>{data.mainProfession}</b>
            <br />
            Мэргэжил: <b>{data.subProfession}</b>
          </div>
        </div>

        <div style={{ marginTop: 15, textAlign: "center" }}>
          {formatDateToMongolian(data.createdAt)}
        </div>

        <div
          style={{
            marginTop: 120,
            display: "flex",
            justifyContent: "space-between",
            fontWeight: "bold",
            fontSize: 14,
            paddingTop: 20,
          }}
        >
          <div style={{ width: "45%", textAlign: "center" }}>
            <b>Т.НЯМ-ОЧИР</b>
            <p style={{ fontSize: "12px", margin: 0 }}>
              Төслийн хэрэгжүүлэгч байгууллага
              <br />
              БОЛОВСРОЛЫН ЕРӨНХИЙ ГАЗАР
            </p>
          </div>
          <div style={{ width: "45%", textAlign: "center" }}>
            <b>С.ГАНТӨР</b>
            <p style={{ fontSize: "12px", margin: 0 }}>
              “ХӨГЖИЛ” Мэргэжлийн чиг баримжаа, боловсрол олгох төв
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
